module.exports = __webpack_public_path__ + "static/media/apple.e84d54ad.svg";